/* IPL Boost — additive conversion layer for product pages (pairs with ipl-boost.css).
   No-ops unless the ipl product section (#iplp) is on the page. Safe to remove. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var root = document.getElementById('iplp');
    if (!root) return;
    var buy = root.querySelector('.iplp__buy');

    /* Working-day helpers, shared by the dispatch promise and the phone status.
       UK bank holidays, England & Wales (source: gov.uk/bank-holidays.json).
       EXTEND THIS LIST BEFORE JANUARY 2029 - past the last year covered the
       code falls back to weekends-only, which is the bug this fixes. */
    var BANK_HOLIDAYS = {
      '2026-01-01': 1, '2026-04-03': 1, '2026-04-06': 1, '2026-05-04': 1,
      '2026-05-25': 1, '2026-08-31': 1, '2026-12-25': 1, '2026-12-28': 1,
      '2027-01-01': 1, '2027-03-26': 1, '2027-03-29': 1, '2027-05-03': 1,
      '2027-05-31': 1, '2027-08-30': 1, '2027-12-27': 1, '2027-12-28': 1,
      '2028-01-03': 1, '2028-04-14': 1, '2028-04-17': 1, '2028-05-01': 1,
      '2028-05-29': 1, '2028-08-28': 1, '2028-12-25': 1, '2028-12-26': 1
    };
    var iso = function (d) {
      return d.getFullYear() + '-' +
             ('0' + (d.getMonth() + 1)).slice(-2) + '-' +
             ('0' + d.getDate()).slice(-2);
    };
    var isWorkingDay = function (d) {
      if (d.getDay() === 0 || d.getDay() === 6) return false;
      return !BANK_HOLIDAYS[iso(d)];
    };
    var fmtRemain = function (mins) {
      var h = Math.floor(mins / 60), m = mins % 60;
      return (h ? h + 'h ' : '') + m + 'm';
    };
    var addWorkingDays = function (d, n) {
      var x = new Date(d);
      while (n > 0) {
        x.setDate(x.getDate() + 1);
        if (isWorkingDay(x)) n--;
      }
      return x;
    };
    var fmtDate = function (d) {
      return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
    };
    var dayName = function (d) {
      return d.toLocaleDateString('en-GB', { weekday: 'long' });
    };
    var daysApart = function (a, b) {
      return Math.round((new Date(iso(b)) - new Date(iso(a))) / 86400000);
    };
    var londonNow = function () {
      return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/London' }));
    };

    /* 1. Open the Specification section by default so key fit info is visible */
    root.querySelectorAll('#iplpAcc summary').forEach(function (s) {
      if (/specification/i.test(s.textContent)) s.parentElement.open = true;
    });

    /* 2. Dispatch promise + free delivery, under the stock line */
    var stock = document.getElementById('iplpStock');
    var dispatchBox = null;
    if (stock && buy) {
      dispatchBox = document.createElement('div');
      dispatchBox.className = 'iplp__dispatch';
      dispatchBox.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 5h11v10H3zM14 8h4l3 3v4h-7zM7.5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm10 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/></svg>' +
        '<div><span id="iplpDispatchMsg"></span>' +
        '<span class="iplp__dispatch-est" id="iplpDispatchEst"></span>' +
        '<span class="iplp__dispatch-free"><b>FREE</b> UK mainland delivery on every order</span></div>';
      stock.insertAdjacentElement('afterend', dispatchBox);

      var tick = function () {
        var el = document.getElementById('iplpDispatchMsg');
        if (!el) return;
        var now = londonNow();
        var mins = now.getHours() * 60 + now.getMinutes();
        var cutoff = 14 * 60; /* 2pm on working days */
        var sameDay = isWorkingDay(now) && mins < cutoff;
        var dispatchDate = sameDay ? new Date(now) : addWorkingDays(now, 1);
        if (sameDay) {
          el.innerHTML = 'Order within <b>' + fmtRemain(cutoff - mins) + '</b> for <b>same-day dispatch</b>';
        } else {
          var gap = daysApart(now, dispatchDate);
          var label;
          if (gap === 1) { label = 'tomorrow'; }
          else if (gap <= 7) { label = dayName(dispatchDate); }
          else { label = fmtDate(dispatchDate); }
          el.innerHTML = 'Order now &mdash; <b>dispatched ' + label + '</b>';
        }
        /* estimated delivery = dispatch day + 2-3 working days transit */
        var estFrom = addWorkingDays(dispatchDate, 2);
        var estTo = addWorkingDays(dispatchDate, 3);
        var estEl = document.getElementById('iplpDispatchEst');
        if (estEl) estEl.innerHTML = 'Estimated delivery: <b>' + fmtDate(estFrom) + ' &ndash; ' + fmtDate(estTo) + '</b>';
      };
      tick();
      setInterval(tick, 30000);

      /* hide the dispatch box if the selected variant goes out of stock */
      new MutationObserver(function () {
        dispatchBox.style.display = stock.classList.contains('is-out') ? 'none' : '';
      }).observe(stock, { attributes: true, childList: true });
    }

    /* 3. Replace the bare "OR" divider with a labelled rule */
    if (buy) {
      Array.prototype.slice.call(buy.querySelectorAll('p')).forEach(function (p) {
        if (p.textContent.trim() === 'OR') {
          var o = document.createElement('div');
          o.className = 'iplp__or';
          o.innerHTML = '<span>or get help &amp; trade pricing</span>';
          p.replaceWith(o);
        }
      });
    }

    /* 4. Trust checklist at the bottom of the buy box.
          The phone line carries a live open/closed state rather than a static
          opening-hours range, so a visitor knows whether calling now will reach
          anyone. Office hours are Mon-Fri 8:30-17:00 Europe/London, excluding
          the bank holidays above. */
    if (buy) {
      var check = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"/></svg>';
      var trust = document.createElement('ul');
      trust.className = 'iplp__trust';
      trust.innerHTML =
        '<li>' + check + '<span><b>Free UK mainland delivery</b> &mdash; <a href="/policies/shipping-policy">delivery details</a></span></li>' +
        '<li>' + check + '<span><b>Easy returns</b></span></li>' +
        '<li>' + check + '<span><b>Secure checkout</b> &mdash; all major cards accepted</span></li>' +
        '<li>' + check + '<span><b>Real UK experts</b> &mdash; call <a href="tel:01282277786">01282 277786</a> <span id="iplpPhoneStatus"></span></span></li>';
      buy.appendChild(trust);

      var OPEN_MIN = 8 * 60 + 30;
      var CLOSE_MIN = 17 * 60;
      var phoneTick = function () {
        var el = document.getElementById('iplpPhoneStatus');
        if (!el) return;
        var now = londonNow();
        var mins = now.getHours() * 60 + now.getMinutes();
        var isOpen = isWorkingDay(now) && mins >= OPEN_MIN && mins < CLOSE_MIN;
        if (isOpen) {
          el.style.color = '#17794a';
          el.style.fontWeight = '700';
          el.innerHTML = '&middot; Open now until 17:00';
        } else {
          var next = (isWorkingDay(now) && mins < OPEN_MIN) ? new Date(now) : addWorkingDays(now, 1);
          var gap = daysApart(now, next);
          var when = gap === 0 ? 'today' : (gap === 1 ? 'tomorrow' : dayName(next));
          el.style.color = '#5c6672';
          el.style.fontWeight = '400';
          el.innerHTML = '&middot; Closed &mdash; opens 8:30 ' + when;
        }
      };
      phoneTick();
      setInterval(phoneTick, 30000);
    }

    /* 4b. Keep the WhatsApp quote message carrying the SKU of the variant that is
           actually selected, so the team can identify it without asking. */
    (function () {
      var wa = root.querySelector('.iplp__wabtn');
      var skuEl = document.getElementById('iplpSku');
      if (!wa || !skuEl) return;
      var titleEl = root.querySelector('.iplp__title');
      var syncWa = function () {
        var sku = (skuEl.textContent || '').trim();
        var title = titleEl ? titleEl.textContent.trim() : document.title;
        var text = 'Hi, I would like a quote for: ' + title +
                   (sku ? ' (SKU ' + sku + ')' : '') +
                   ' - ' + location.href.split('?')[0];
        try {
          var u = new URL(wa.getAttribute('href'), location.origin);
          u.searchParams.set('text', text);
          wa.setAttribute('href', u.toString());
        } catch (e) {}
      };
      syncWa();
      new MutationObserver(syncWa).observe(skuEl, { childList: true, characterData: true, subtree: true });
    })();

    /* 5. Fit-checker / ask-a-specialist card under the buy box */
    var wrap = root.querySelector('.iplp__buywrap');
    if (wrap) {
      var isSeal = !!root.querySelector('.iplp__x a[href*="seals-for-"]');
      var mail = 'sales@industrial-polymers.co.uk';
      var subj = encodeURIComponent('Fit check: ' + document.title);
      var body = encodeURIComponent('Hi,\n\nPlease help me check this fits.\n\nProduct: ' + location.href + '\n\nI\'ve attached a photo of my current seal/part and its measurements.\n\nThanks');
      var mailIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"/></svg>';
      var fit = document.createElement('div');
      fit.className = 'iplp__fit';
      if (isSeal) {
        fit.innerHTML =
          '<h3>Not sure this seal fits?</h3>' +
          '<p>Email a photo of your old seal (or your door gap measurement) and our team will match the right profile for you &mdash; usually the same working day.</p>' +
          '<a class="iplp__fit-btn" href="mailto:' + mail + '?subject=' + subj + '&body=' + body + '">' + mailIcon + 'Email a photo &mdash; free fit check</a>';
      } else {
        fit.innerHTML =
          '<h3>Need help choosing the right spec?</h3>' +
          '<p>Send us what you\'re working on and a UK specialist will confirm the right material, grade or size before you buy.</p>' +
          '<a class="iplp__fit-btn" href="mailto:' + mail + '?subject=' + subj + '&body=' + body + '">' + mailIcon + 'Ask a specialist &mdash; free advice</a>';
      }
      wrap.appendChild(fit);
    }

    /* 6a. Variant pills: show the price under each option (single-option products) */
    (function () {
      var opts = root.querySelectorAll('.iplp__opt');
      if (opts.length !== 1) return;
      var pills = opts[0].querySelectorAll('[data-optpill]');
      if (!pills.length) return;
      fetch(location.pathname.split('?')[0] + '.js').then(function (r) { return r.json(); }).then(function (p) {
        if (!p || !p.variants) return;
        var map = {};
        p.variants.forEach(function (v) { if (map[v.option1] === undefined) map[v.option1] = v.price; });
        pills.forEach(function (pl) {
          var val = pl.getAttribute('data-value');
          if (map[val] !== undefined && !pl.querySelector('.iplp__pill-price')) {
            var s = document.createElement('span');
            s.className = 'iplp__pill-price';
            s.textContent = '£' + (map[val] / 100).toFixed(2);
            pl.appendChild(s);
          }
        });
      }).catch(function () {});
    })();

    /* 6b. Image lightbox: click the main image to view it full-screen */
    (function () {
      var main = document.getElementById('iplpMain');
      if (!main) return;
      var lb = document.createElement('div');
      lb.className = 'iplp__lb';
      lb.innerHTML = '<img alt="Full-size product image"><button type="button" class="iplp__lb-close" aria-label="Close image">&times;</button>';
      document.body.appendChild(lb);
      var lbImg = lb.querySelector('img');
      main.addEventListener('click', function () {
        lbImg.src = main.src;
        lb.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
      var closeLb = function () { lb.classList.remove('is-open'); document.body.style.overflow = ''; };
      lb.addEventListener('click', closeLb);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });
    })();

    /* 6. Sticky mobile buy bar (shows when the main Add to basket is off-screen) */
    var atc = document.getElementById('iplpAtc');
    if (atc) {
      var bar = document.createElement('div');
      bar.className = 'iplp__bar';
      bar.id = 'iplpBar';
      bar.innerHTML =
        '<div class="iplp__bar-info"><span class="iplp__bar-price" id="iplpBarPrice"></span>' +
        '<span class="iplp__bar-sub">Free UK delivery</span></div>' +
        '<button type="button" class="iplp__bar-atc" id="iplpBarAtc">Add to basket</button>';
      document.body.appendChild(bar);

      var priceEl = document.getElementById('iplpBuyPrice');
      var barPrice = document.getElementById('iplpBarPrice');
      var barAtc = document.getElementById('iplpBarAtc');

      var syncBar = function () {
        if (priceEl && barPrice) barPrice.textContent = priceEl.textContent;
        barAtc.disabled = atc.disabled;
        var t = atc.textContent.trim();
        barAtc.textContent = (t === 'Sold out') ? 'Sold out' : (t === 'Adding...' ? 'Adding...' : 'Add to basket');
      };
      syncBar();
      if (priceEl) new MutationObserver(syncBar).observe(priceEl, { childList: true, characterData: true, subtree: true });
      new MutationObserver(syncBar).observe(atc, { attributes: true, childList: true, subtree: true });

      barAtc.addEventListener('click', function () {
        if (barAtc.disabled) return;
        barAtc.disabled = true;
        barAtc.textContent = 'Adding...';
        atc.click();
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          bar.classList.toggle('is-visible', !entries[0].isIntersecting);
        }, { threshold: 0 }).observe(atc);
      } else {
        bar.classList.add('is-visible');
      }
    }
  });
})();